












import { Component, Prop, Vue } from 'vue-property-decorator';

import PresetService from '@/services/user_preset_service';

@Component({
  name: 'CardHeader',
  components: {
  }
})
export default class  extends Vue {
  @Prop() public blockHeader!: string;
  @Prop({default: false}) public showDouble!: boolean;

  get cssVars() {
    return {
      '--width': PresetService.cardWidth + 'px'
    }
  }

}
